import { JSX, ReactNode, FormEvent } from "react";

interface Props {
    children: ReactNode;
    onSubmit: (event: FormEvent<HTMLFormElement>) => Promise<void>;
}

export const FormWrapper = (props: Props): JSX.Element => {
    const { children, onSubmit } = props;

    return (
        <form
            className={"c-schedule-qualification-modal__form c-form"}
            onSubmit={onSubmit}
        >
            {children}
        </form>
    );
};
